import ObjectPivotLink from "./object-pivot-link.js";

class ObjectPivotWrapper {
    constructor() {
        this._object = null;
        this._pivot = null;

        this._link = new ObjectPivotLink();

        this._position = new PositionVector3(this._link);
        this._quaternion = new Quaternion(this._link);
        this._scale = new ScaleVector3(this._link);
        this._matrix = new THREE.Matrix4();
        this._matrixWorld = new THREE.Matrix4();
    }

    setObjectAndPivot(object, pivot) {
        this._object = object;
        this._pivot = pivot;

        this._link.attach(object, pivot);

        if (object && pivot) {
            this._quaternion._updateFromLink();
        }
    }

    get uuid() {
        return this._object.uuid;
    }

    get position() {
        return this._position;
    }

    get quaternion() {
        return this._quaternion;
    }

    get scale() {
        return this._scale;
    }

    get parent() {
        return this._object.parent;
    }

    get matrix() {
        return this._matrix;
    }

    get matrixWorld() {
        return this._matrixWorld;
    }

    updateMatrix() {
        this._matrix.compose(this._position, this._quaternion, this._scale);
    }

    updateMatrixWorld() {
        this.updateMatrix();

        if (this.parent) {
            this._matrixWorld.multiplyMatrices(this.parent.matrixWorld, this._matrix);
        } else {
            this._matrixWorld.copy(this._matrix);
        }
    }
}

const tmpVec = new THREE.Vector3();
const tmpQuat = new THREE.Quaternion();

class PositionVector3 extends THREE.Vector3 {
    constructor(link) {
        super();

        Object.defineProperties(this, Object.fromEntries(["x", "y", "z"].map(k => {
            return [k, {
                enumerable: true,
                configurable: true,
                get: () => this._getCoord(k),
                set: (value) => this._setCoord(k, value),
            }];
        })));

        this._link = link;
    }

    _getCoord(k) {
        return this._link.getPosition(tmpVec)[k];
    }

    _setCoord(k, v) {
        const pos = this._link.getPosition(tmpVec);
        pos[k] = v;
        this._link.setPosition(pos);
    }
}

class Quaternion extends THREE.Quaternion {
    constructor(link) {
        super();

        this._link = link;
        this.onChange(this._updateLinkOnChange.bind(this));
    }

    _updateFromLink() {
        const quat = this._link.getQuaternion(tmpQuat);
        this.copy(quat);
    }

    _updateLinkOnChange() {
        this._link.setQuaternion(this);
    }
}

class ScaleVector3 extends THREE.Vector3 {
    constructor(link) {
        super();

        Object.defineProperties(this, Object.fromEntries(["x", "y", "z"].map(k => {
            return [k, {
                enumerable: true,
                configurable: true,
                get: () => this._getCoord(k),
                set: (value) => this._setCoord(k, value),
            }];
        })));

        this._link = link;
    }

    _getCoord(k) {
        return this._link.getScale(tmpVec)[k];
    }

    _setCoord(k, v) {
        const pos = this._link.getScale(tmpVec);
        pos[k] = v;
        this._link.setScale(pos);
    }
}

export default ObjectPivotWrapper;
